import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    color: "#4A148C",
    title: "The Craft",
    body: "Our Proppadoms are rolled thin, seasoned properly and packed the same week they're made. No shortcuts, no stale stock — just the crackle you expect when the chutney hits.",
  },
  {
    num: "02",
    color: "#4A148C",
    title: "The Dip Rule",
    body: "A Proppadom without mango chutney is a cricket match without tea. Ours is sweet, sharp and sticky enough to steal the show on any curry night.",
  },
  {
    num: "03",
    color: "#4A148C",
    title: "For Pubs & Takeaways",
    body: "We supply the trade with cases of Proppadoms, dips and Bombay mix at proper wholesale prices. One form below, one human reply, zero faff.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="relative py-24 lg:py-32 bg-white overflow-hidden" data-testid="manifesto-section">
    <div className="max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
      <div className="lg:col-span-7">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
              className="inline-block bg-white border border-[#2B0B3C]/15 rounded-full px-5 py-2 text-xs font-bold tracking-[0.15em] uppercase text-[#2B0B3C]/70 mb-12"
        >
          The Manifesto
        </motion.p>
        <div>
          {chapters.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: 0.05 * i, ease: [0.22, 1, 0.36, 1] }}
              className="flex gap-6 lg:gap-10 py-10 border-t-4 border-[#2B0B3C]/10 first:border-t-0"
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <span
                className="shrink-0 w-14 h-14 lg:w-16 lg:h-16 rounded-full flex items-center justify-center font-display font-bold text-xl text-white"
                style={{ backgroundColor: c.color }}
              >
                {c.num}
              </span>
              <div>
                <h3 className="font-display text-3xl lg:text-4xl font-bold tracking-tight text-[#2B0B3C]">{c.title}</h3>
                <p className="mt-3 text-base lg:text-lg font-medium leading-relaxed text-[#2B0B3C]/65 max-w-xl">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <div className="lg:col-span-5 relative">
        <motion.div
          initial={{ opacity: 0, rotate: 0, y: 40 }}
          whileInView={{ opacity: 1, rotate: 2, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="rounded-[28px] overflow-hidden shadow-[0_24px_60px_-20px_rgba(43,11,60,0.3)] lg:sticky lg:top-28"
        >
          <img
            src="https://images.unsplash.com/photo-1594035900144-17151c9910af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxwdWIlMjBmcmllbmRzJTIwYmVlcnxlbnwwfHx8fDE3ODUzNTc0MTR8MA&ixlib=rb-4.1.0&q=85"
            alt="Friends sharing pints and snacks at the pub"
            loading="lazy"
            className="w-full h-[420px] lg:h-[520px] object-cover"
            data-testid="manifesto-image"
          />
          <div className="bg-[#FFD600] px-6 py-4">
            <p className="font-display font-bold uppercase text-[#2B0B3C]">Best mates with a pint</p>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
